import { isSourceInProgram } from '@shoflo/polymer';
import { logProgramChange } from '@shoflo/studio-redux/utils';
import setProgram from './setProgram';
import { sceneBuilder } from '@studio/program/sceneBuilder/sceneBuilder';
import { withCurrentParams } from 'actions/utils';
import { PRESENTER_FEATURE } from 'store/eventConstants';
import { attachAudioPresenterSources } from 'utils/broadcastSourceHelper';

const setFeaturedPresenter = presenterId => {
  return withCurrentParams((dispatch, { broadcastId }, getState, socket) => {
    const {
      banners,
      sceneLayout,
      sceneLayers,
      attendeeMuteStatus,
      program: { layers },
      meeting: { attendeeResponse },
      brandingSettings
    } = getState();

    const combinedLayers = [...sceneLayers, ...banners];
    const sources = layers.map(({ source, _id }) => {
      return {
        ...source,
        featured: _id === presenterId
      };
    });

    const withAudioPresenterSources = attachAudioPresenterSources(
      sources,
      attendeeMuteStatus
    );

    const scene = sceneBuilder(
      sceneLayout,
      withAudioPresenterSources,
      combinedLayers,
      {},
      {},
      brandingSettings?.fonts
    );
    // notify other directors
    socket.emit(PRESENTER_FEATURE, {
      presenterId,
      broadcastId,
      notifyingDirector:
        attendeeResponse && attendeeResponse.Attendee.AttendeeId
    });

    const isLiveSource = isSourceInProgram(layers, presenterId);

    if (isLiveSource) {
      dispatch(setProgram(scene));
      logProgramChange(getState, 'setFeaturedPresenter action');
    }
  });
};

export default setFeaturedPresenter;
